import { forwardRef, useImperativeHandle, useState } from 'react';
import { ChronologyModalRef } from './types';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import XmarkIcon from '@/app/assets/icons/xmark.svg?react';
import { DealRequest } from '@/app/api/types';
import { ChronologyFlow } from '@/features/chronology-flow';
import { useNavigate } from 'react-router-dom';

export const ChronologyModal = forwardRef<ChronologyModalRef>((_, ref) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [open, setOpen] = useState<boolean>(false);
  const [row, setRow] = useState<DealRequest>();
  const [backUrl, setBackUrl] = useState<string>('');

  const onOpen: ChronologyModalRef['open'] = ({ row, backUrl }) => {
    setOpen(true);
    setRow(row);
    setBackUrl(backUrl);
  };

  useImperativeHandle(ref, () => ({
    open: onOpen,
  }));

  const onClose = () => {
    setOpen(false);
  };

  const onOpenDeal = () => {
    if (!row) return;
    navigate(`/factor/requests/${row.unique}?backUrl=${backUrl}`);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          minHeight: '45vh',
          maxWidth: 540,
          width: '100%',
        },
      }}
    >
      <DialogTitle
        sx={{
          background: '#F8F8F9',
        }}
      >
        <Stack
          direction='row'
          justifyContent='space-between'
          alignItems='center'
        >
          <Typography sx={{ fontSize: '1.7rem', fontWeight: 600 }}>
            {t('chronology.title')}
          </Typography>

          <Tooltip title={t('close')}>
            <IconButton
              onClick={onClose}
              sx={{
                height: '40px',
                width: '40px',
                borderRadius: '50%',
                mr: '-8px',
                opacity: 0.5,
              }}
            >
              <XmarkIcon />
            </IconButton>
          </Tooltip>
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ mt: 3 }}>
        <ChronologyFlow row={row} />
      </DialogContent>
      <DialogActions sx={{ p: 4, pt: 0 }}>
        <Button color='primary' onClick={onOpenDeal}>
          {t('chronology.open_deal')}
        </Button>
      </DialogActions>
    </Dialog>
  );
});
